export default __webpack_public_path__ + "static/media/img-0347-ukraine-half-face.d9655422.png";